export default __webpack_public_path__ + "static/media/plytkapo.c7fe7ada.jpg";